export const sections = [
	{
		emoji: '📚',
		title: 'Bitcoin para principiantes',
		description:
			'Aprende qué es bitcoin, por qué lo usamos y cómo empezar a ganar sats.',
		link: '/client/education/bitcoin-basics',
		identifier: 'basics',
	},
	{
		emoji: '⚡',
		title: 'Lightning Network',
		description:
			'Descubre cómo funciona Lightning y cómo recibir tu cashback instantáneamente.',
		link: '/client/education/lightning',
		identifier: 'lightning',
	},
	{
		emoji: '🛍️',
		title: 'Gana más cashback',
		description:
			'Tips para maximizar tus recompensas, aprovechar promociones y referir amigos.',
		link: '/client/education/cashback',
		identifier: 'cashback',
	},
	{
		emoji: '🔐',
		title: 'Seguridad & privacidad',
		description:
			'Protege tu cuenta y aprende cómo cuidamos tus datos en Bumbei.',
		link: '/client/education/security',
		identifier: 'security',
	},
	{
		emoji: '💡',
		title: '¿Cómo ganamos cashback?',
		description:
			'Descubre por qué las marcas nos pagan comisión y cómo la compartimos contigo en bitcoin.',
		link: '/client/education/why-cashback',
		identifier: 'why-cashback',
	},
];
